export interface OrderItem {
  nomenclature: string;
  quantity: number;
  price: number;
  sum: number;
}

export interface Order {
  id: string;
  date: string;
  client: string;
  manager: string;
  amount: number;
  margin: number;
  status: string;
  shipmentDate: string;
  currency: string;
  deal: string;
  organization: string;
  operation: string;
  items: OrderItem[];
}

export const orders: Order[] = [
  {
    id: "Т000-000101",
    date: "2025-01-15",
    client: "ООО Швейная Фабрика №1",
    manager: "Иванов А.С.",
    amount: 487500.00,
    margin: 146250.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-01-28",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейная Фабрика №1",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 800, price: 375.00, sum: 300000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 2500, price: 75.00, sum: 187500.00 },
    ],
  },
  {
    id: "Т000-000102",
    date: "2025-02-03",
    client: "ООО ТекстильПро",
    manager: "Петров Д.Н.",
    amount: 756000.00,
    margin: 226800.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-02-10",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО ТекстильПро",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань лён арт. ЛН-200", quantity: 600, price: 720.00, sum: 432000.00 },
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 600, price: 380.00, sum: 228000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 1600, price: 60.00, sum: 96000.00 },
    ],
  },
  {
    id: "Т000-000103",
    date: "2025-03-12",
    client: "АО Модный Дом",
    manager: "Сидорова Е.М.",
    amount: 1240000.00,
    margin: 372000.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-03-25",
    currency: "RUB",
    deal: "",
    organization: "АО Модный Дом",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань шёлк арт. ШЛ-500", quantity: 350, price: 1800.00, sum: 630000.00 },
      { nomenclature: "Ткань шерсть арт. ШР-300", quantity: 280, price: 1550.00, sum: 434000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 1100, price: 160.00, sum: 176000.00 },
    ],
  },
  {
    id: "Т000-000104",
    date: "2025-04-08",
    client: "ООО Спецодежда Плюс",
    manager: "Иванов А.С.",
    amount: 325000.00,
    margin: 97500.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-04-18",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Спецодежда Плюс",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань джинсовая арт. ДЖ-800", quantity: 300, price: 650.00, sum: 195000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 2000, price: 65.00, sum: 130000.00 },
    ],
  },
  {
    id: "Т000-000105",
    date: "2025-05-20",
    client: "ООО Домашний Текстиль",
    manager: "Петров Д.Н.",
    amount: 612000.00,
    margin: 183600.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-06-02",
    currency: "RUB",
    deal: "",
    organization: "ООО Домашний Текстиль",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 1200, price: 350.00, sum: 420000.00 },
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 800, price: 240.00, sum: 192000.00 },
    ],
  },
  {
    id: "Т000-000106",
    date: "2025-06-15",
    client: "ООО Швейное Объединение Восток",
    manager: "Сидорова Е.М.",
    amount: 1875000.00,
    margin: 562500.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-07-01",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейное Объединение Восток",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань костюмная арт. КС-400", quantity: 500, price: 1350.00, sum: 675000.00 },
      { nomenclature: "Ткань шерсть арт. ШР-300", quantity: 400, price: 1500.00, sum: 600000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 2500, price: 120.00, sum: 300000.00 },
      { nomenclature: "Молнии YKK 60см", quantity: 1500, price: 200.00, sum: 300000.00 },
    ],
  },
  {
    id: "Т000-000107",
    date: "2025-07-22",
    client: "ООО ТексПром",
    manager: "Иванов А.С.",
    amount: 168000.00,
    margin: 50400.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-07-30",
    currency: "RUB",
    deal: "",
    organization: "ООО ТексПром",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 200, price: 480.00, sum: 96000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 1200, price: 60.00, sum: 72000.00 },
    ],
  },
  {
    id: "Т000-000108",
    date: "2025-08-10",
    client: "ООО ТекстильПро",
    manager: "Петров Д.Н.",
    amount: 432000.00,
    margin: 129600.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-08-22",
    currency: "RUB",
    deal: "",
    organization: "ООО ТекстильПро",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань лён арт. ЛН-200", quantity: 400, price: 700.00, sum: 280000.00 },
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 400, price: 380.00, sum: 152000.00 },
    ],
  },
  {
    id: "Т000-000109",
    date: "2025-09-18",
    client: "ООО Спецодежда Плюс",
    manager: "Сидорова Е.М.",
    amount: 780000.00,
    margin: 234000.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-10-03",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Спецодежда Плюс",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань джинсовая арт. ДЖ-800", quantity: 600, price: 620.00, sum: 372000.00 },
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 500, price: 456.00, sum: 228000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 3000, price: 60.00, sum: 180000.00 },
    ],
  },
  {
    id: "Т000-000110",
    date: "2025-10-25",
    client: "ООО Гардинная Мануфактура",
    manager: "Иванов А.С.",
    amount: 357000.00,
    margin: 107100.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-11-08",
    currency: "RUB",
    deal: "",
    organization: "ООО Гардинная Мануфактура",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 1500, price: 238.00, sum: 357000.00 },
    ],
  },
  {
    id: "Т000-000111",
    date: "2025-11-14",
    client: "АО Модный Дом",
    manager: "Петров Д.Н.",
    amount: 1860000.00,
    margin: 558000.00,
    status: "В процессе отгрузки",
    shipmentDate: "2025-11-28",
    currency: "RUB",
    deal: "Реализация",
    organization: "АО Модный Дом",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань шёлк арт. ШЛ-500", quantity: 500, price: 1750.00, sum: 875000.00 },
      { nomenclature: "Ткань костюмная арт. КС-400", quantity: 400, price: 1280.00, sum: 512000.00 },
      { nomenclature: "Ткань шерсть арт. ШР-300", quantity: 220, price: 1450.00, sum: 319000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 1200, price: 128.33, sum: 154000.00 },
    ],
  },
  {
    id: "Т000-000112",
    date: "2025-12-02",
    client: "ООО Мебельный Текстиль",
    manager: "Сидорова Е.М.",
    amount: 495000.00,
    margin: 148500.00,
    status: "Готов к закрытию",
    shipmentDate: "2025-12-18",
    currency: "RUB",
    deal: "",
    organization: "ООО Мебельный Текстиль",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 750, price: 440.00, sum: 330000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 2200, price: 75.00, sum: 165000.00 },
    ],
  },
  {
    id: "Т000-000113",
    date: "2025-12-20",
    client: "ООО Швейная Фабрика №1",
    manager: "Иванов А.С.",
    amount: 1125000.00,
    margin: 337500.00,
    status: "В процессе отгрузки",
    shipmentDate: "2026-01-10",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейная Фабрика №1",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 2000, price: 340.00, sum: 680000.00 },
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 1200, price: 225.00, sum: 270000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 3500, price: 50.00, sum: 175000.00 },
    ],
  },
  {
    id: "Т000-000114",
    date: "2026-01-25",
    client: "ООО ТекстильПро",
    manager: "Петров Д.Н.",
    amount: 648000.00,
    margin: 194400.00,
    status: "Готов к закрытию",
    shipmentDate: "2026-02-07",
    currency: "RUB",
    deal: "",
    organization: "ООО ТекстильПро",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань лён арт. ЛН-200", quantity: 450, price: 680.00, sum: 306000.00 },
      { nomenclature: "Ткань джинсовая арт. ДЖ-800", quantity: 380, price: 600.00, sum: 228000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 1900, price: 60.00, sum: 114000.00 },
    ],
  },
  {
    id: "Т000-000115",
    date: "2026-02-14",
    client: "ООО Домашний Текстиль",
    manager: "Сидорова Е.М.",
    amount: 215000.00,
    margin: 64500.00,
    status: "Ожидается оплата",
    shipmentDate: "2026-02-25",
    currency: "RUB",
    deal: "",
    organization: "ООО Домашний Текстиль",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 500, price: 370.00, sum: 185000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 600, price: 50.00, sum: 30000.00 },
    ],
  },
  {
    id: "Т000-000116",
    date: "2026-03-08",
    client: "АО Модный Дом",
    manager: "Иванов А.С.",
    amount: 2190000.00,
    margin: 657000.00,
    status: "Ожидается обеспечение",
    shipmentDate: "2026-04-01",
    currency: "RUB",
    deal: "Реализация",
    organization: "АО Модный Дом",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань шёлк арт. ШЛ-500", quantity: 600, price: 1700.00, sum: 1020000.00 },
      { nomenclature: "Ткань костюмная арт. КС-400", quantity: 500, price: 1300.00, sum: 650000.00 },
      { nomenclature: "Ткань шерсть арт. ШР-300", quantity: 200, price: 1400.00, sum: 280000.00 },
      { nomenclature: "Молнии YKK 60см", quantity: 1200, price: 200.00, sum: 240000.00 },
    ],
  },
  {
    id: "Т000-000117",
    date: "2026-04-22",
    client: "ООО ТексПром",
    manager: "Петров Д.Н.",
    amount: 454000.00,
    margin: 136200.00,
    status: "Готов к отгрузке",
    shipmentDate: "2026-05-05",
    currency: "RUB",
    deal: "",
    organization: "ООО ТексПром",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 500, price: 460.00, sum: 230000.00 },
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 700, price: 220.00, sum: 154000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 1000, price: 70.00, sum: 70000.00 },
    ],
  },
  {
    id: "Т000-000118",
    date: "2026-05-15",
    client: "ООО Швейное Объединение Восток",
    manager: "Сидорова Е.М.",
    amount: 1520000.00,
    margin: 456000.00,
    status: "Ожидается обеспечение",
    shipmentDate: "2026-06-01",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейное Объединение Восток",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань костюмная арт. КС-400", quantity: 600, price: 1250.00, sum: 750000.00 },
      { nomenclature: "Ткань лён арт. ЛН-200", quantity: 500, price: 660.00, sum: 330000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 2200, price: 135.00, sum: 297000.00 },
      { nomenclature: "Молнии YKK 60см", quantity: 650, price: 220.00, sum: 143000.00 },
    ],
  },
  {
    id: "Т000-000119",
    date: "2026-06-02",
    client: "ООО Спецодежда Плюс",
    manager: "Иванов А.С.",
    amount: 685000.00,
    margin: 205500.00,
    status: "В процессе отгрузки",
    shipmentDate: "2026-06-15",
    currency: "RUB",
    deal: "",
    organization: "ООО Спецодежда Плюс",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань джинсовая арт. ДЖ-800", quantity: 500, price: 600.00, sum: 300000.00 },
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 450, price: 440.00, sum: 198000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 3400, price: 55.00, sum: 187000.00 },
    ],
  },
  {
    id: "Т000-000120",
    date: "2026-06-10",
    client: "ООО Иголочка",
    manager: "Петров Д.Н.",
    amount: 187000.00,
    margin: 56100.00,
    status: "Готов к отгрузке",
    shipmentDate: "2026-06-18",
    currency: "RUB",
    deal: "",
    organization: "ООО Иголочка",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Нитки полиэстер №40", quantity: 1200, price: 72.00, sum: 86400.00 },
      { nomenclature: "Нитки х/б №30", quantity: 800, price: 58.00, sum: 46400.00 },
      { nomenclature: "Нитки армированные №70", quantity: 280, price: 165.00, sum: 46200.00 },
      { nomenclature: "Молнии YKK 60см", quantity: 40, price: 200.00, sum: 8000.00 },
    ],
  },
  {
    id: "Т000-000121",
    date: "2026-06-20",
    client: "ООО Швейная Фабрика №1",
    manager: "Иванов А.С.",
    amount: 423000.00,
    margin: 126900.00,
    status: "В процессе отгрузки",
    shipmentDate: "2026-06-24",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейная Фабрика №1",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 900, price: 350.00, sum: 315000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 1800, price: 60.00, sum: 108000.00 },
    ],
  },
  {
    id: "Т000-000122",
    date: "2026-06-20",
    client: "ООО Гардинная Мануфактура",
    manager: "Сидорова Е.М.",
    amount: 287000.00,
    margin: 86100.00,
    status: "Готов к отгрузке",
    shipmentDate: "2026-06-22",
    currency: "RUB",
    deal: "",
    organization: "ООО Гардинная Мануфактура",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 700, price: 230.00, sum: 161000.00 },
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 180, price: 450.00, sum: 81000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 750, price: 60.00, sum: 45000.00 },
    ],
  },
  {
    id: "Т000-000123",
    date: "2026-06-21",
    client: "ООО ТекстильПро",
    manager: "Петров Д.Н.",
    amount: 536000.00,
    margin: 160800.00,
    status: "Ожидается оплата",
    shipmentDate: "2026-06-30",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО ТекстильПро",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань лён арт. ЛН-200", quantity: 400, price: 680.00, sum: 272000.00 },
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 500, price: 360.00, sum: 180000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 600, price: 140.00, sum: 84000.00 },
    ],
  },
  {
    id: "Т000-000124",
    date: "2026-06-21",
    client: "АО Модный Дом",
    manager: "Сидорова Е.М.",
    amount: 945000.00,
    margin: 283500.00,
    status: "Ожидается обеспечение",
    shipmentDate: "2026-07-10",
    currency: "RUB",
    deal: "",
    organization: "АО Модный Дом",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань шёлк арт. ШЛ-500", quantity: 300, price: 1750.00, sum: 525000.00 },
      { nomenclature: "Ткань костюмная арт. КС-400", quantity: 250, price: 1280.00, sum: 320000.00 },
      { nomenclature: "Нитки армированные №70", quantity: 800, price: 125.00, sum: 100000.00 },
    ],
  },
  {
    id: "Т000-000125",
    date: "2026-06-22",
    client: "ООО Домашний Текстиль",
    manager: "Иванов А.С.",
    amount: 380000.00,
    margin: 114000.00,
    status: "В процессе отгрузки",
    shipmentDate: "2026-06-25",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Домашний Текстиль",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 800, price: 340.00, sum: 272000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 1800, price: 60.00, sum: 108000.00 },
    ],
  },
  {
    id: "Т000-000126",
    date: "2026-06-22",
    client: "ООО Спецодежда Плюс",
    manager: "Петров Д.Н.",
    amount: 738000.00,
    margin: 221400.00,
    status: "Ожидается оплата",
    shipmentDate: "2026-07-01",
    currency: "RUB",
    deal: "",
    organization: "ООО Спецодежда Плюс",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань джинсовая арт. ДЖ-800", quantity: 600, price: 590.00, sum: 354000.00 },
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 500, price: 440.00, sum: 220000.00 },
      { nomenclature: "Молнии YKK 60см", quantity: 820, price: 200.00, sum: 164000.00 },
    ],
  },
  {
    id: "Т000-000127",
    date: "2025-04-01",
    client: "ООО ТексПром",
    manager: "Сидорова Е.М.",
    amount: 92000.00,
    margin: 27600.00,
    status: "Просрочен",
    shipmentDate: "2025-04-10",
    currency: "RUB",
    deal: "",
    organization: "ООО ТексПром",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 400, price: 230.00, sum: 92000.00 },
    ],
  },
  {
    id: "Т000-000128",
    date: "2025-09-05",
    client: "ООО Мебельный Текстиль",
    manager: "Иванов А.С.",
    amount: 156000.00,
    margin: 46800.00,
    status: "Просрочен",
    shipmentDate: "2025-09-15",
    currency: "RUB",
    deal: "",
    organization: "ООО Мебельный Текстиль",
    operation: "Склад и доставка",
    items: [
      { nomenclature: "Ткань плащёвая арт. ПЛ-150", quantity: 300, price: 520.00, sum: 156000.00 },
    ],
  },
  {
    id: "Т000-000129",
    date: "2026-01-10",
    client: "ООО Гардинная Мануфактура",
    manager: "Петров Д.Н.",
    amount: 204000.00,
    margin: 61200.00,
    status: "Просрочен",
    shipmentDate: "2026-01-20",
    currency: "RUB",
    deal: "",
    organization: "ООО Гардинная Мануфактура",
    operation: "Реализация товаров",
    items: [
      { nomenclature: "Ткань подкладочная арт. ПД-50", quantity: 600, price: 240.00, sum: 144000.00 },
      { nomenclature: "Нитки х/б №30", quantity: 1000, price: 60.00, sum: 60000.00 },
    ],
  },
  {
    id: "Т000-000130",
    date: "2026-03-20",
    client: "ООО Швейная Фабрика №1",
    manager: "Сидорова Е.М.",
    amount: 575000.00,
    margin: 172500.00,
    status: "Просрочен",
    shipmentDate: "2026-04-05",
    currency: "RUB",
    deal: "Реализация",
    organization: "ООО Швейная Фабрика №1",
    operation: "Казначейство",
    items: [
      { nomenclature: "Ткань х/б арт. ТХ-100", quantity: 1200, price: 340.00, sum: 408000.00 },
      { nomenclature: "Нитки полиэстер №40", quantity: 2500, price: 66.80, sum: 167000.00 },
    ],
  },
];

export const managers = ["Иванов А.С.", "Петров Д.Н.", "Сидорова Е.М."];

export const clients = [
  "ООО Швейная Фабрика №1",
  "ООО ТекстильПро",
  "АО Модный Дом",
  "ООО Спецодежда Плюс",
  "ООО Домашний Текстиль",
  "ООО Швейное Объединение Восток",
  "ООО ТексПром",
  "ООО Гардинная Мануфактура",
  "ООО Мебельный Текстиль",
  "ООО Иголочка",
];